__turbopack_context__.v({
  "brandRu": "styles-module__BS_R4W__brandRu",
  "brandRuMobile": "styles-module__BS_R4W__brandRuMobile",
  "header": "styles-module__BS_R4W__header",
  "headerContainer": "styles-module__BS_R4W__headerContainer",
  "icon": "styles-module__BS_R4W__icon",
  "iconButton": "styles-module__BS_R4W__iconButton",
  "icons": "styles-module__BS_R4W__icons",
  "logo": "styles-module__BS_R4W__logo",
  "logoWrap": "styles-module__BS_R4W__logoWrap",
  "menuButton": "styles-module__BS_R4W__menuButton",
  "mobileHeader": "styles-module__BS_R4W__mobileHeader",
  "mobileIcons": "styles-module__BS_R4W__mobileIcons",
  "mobileLogo": "styles-module__BS_R4W__mobileLogo",
  "mobileLogoWrap": "styles-module__BS_R4W__mobileLogoWrap",
  "mobileMenu": "styles-module__BS_R4W__mobileMenu",
  "mobileNavLink": "styles-module__BS_R4W__mobileNavLink",
  "mobileTelegram": "styles-module__BS_R4W__mobileTelegram",
  "navLink": "styles-module__BS_R4W__navLink",
  "navigation": "styles-module__BS_R4W__navigation",
  "open": "styles-module__BS_R4W__open",
  "scrolled": "styles-module__BS_R4W__scrolled",
});
